import { createSelector } from 'reselect';
import { RecordOf } from 'immutable';
import { RootState } from 'store';

const selectDashboardState = () => (state: RecordOf<RootState>) => state.get('telematics');

export const selectEnrolments = () => createSelector(selectDashboardState(), (substate) => substate.get('enrolments'));

export const selectEnrolmentsValues = () => createSelector(selectEnrolments(), (enrolments) => enrolments.values);

export const selectEnrolmentsLoading = () => createSelector(selectEnrolments(), (enrolments) => enrolments.loading);

export const selectDataSources = () =>
  createSelector(selectDashboardState(), (substate) => substate.get('datasources'));

export const selectDataSourcesValues = () => createSelector(selectDataSources(), (dataSources) => dataSources.values);

export const selectDataSourcesLoading = () => createSelector(selectDataSources(), (dataSources) => dataSources.loading);
